
export default {
    props: {
        filterFn: Function,
        showOnEmpty: Boolean,
    },

    data() {
        return {
            textFilterFn: null,
        };
    },

    methods: {
        combinedFilterFn(item) {
            return (
                (!this.filterFn || this.filterFn(item)) &&
                (!this.textFilterFn || this.textFilterFn(item))
            );
        },
        onFilter(val, update, abort) {
            // Split needle into space-delimited chunks
            const needles = $.removeAccents(val).toLowerCase().split(/ +/);

            update(() => {
                if (!val.length) {
                    if (this.showOnEmpty) {
                        // Include all options
                        this.textFilterFn = null;
                    } else {
                        // Include no options
                        this.textFilterFn = () => false;
                    }
                } else {
                    // Include option if at least one chunk is found
                    this.textFilterFn = v => needles.find(n => this.getSearchText(v).includes(n));
                }
            });
        },
    },
};
